import { useRef } from "react";

import ConfirmationPopover from "@/appComponents/Blocks/Composites/ConfirmationPopover/ConfirmationPopover";
import { appstr } from "@coreapp/utils/appstr";
import { Text, Tooltip } from "@theorgchartdev/storybook";

export const DeleteBaseChartPopover = ({
  handleDelete,
  dataTestId,
  disabled = false,
  tooltipMessage
}) => {
  const openCtrlRef = useRef(null);

  return (
    <Tooltip message={tooltipMessage ?? appstr("Delete chart")} referenceOpenCtrlRef={openCtrlRef}>
      <ConfirmationPopover
        openCtrlRef={openCtrlRef}
        onSubmit={handleDelete}
        icon={"trash-can"}
        color="error"
        iconOnly
        iconProps={{
          size: "small"
        }}
        otherHeaderProps={{ title: appstr("Delete base chart") }}
        confirmLabel={appstr("Delete")}
        triggerTestId={dataTestId}
        dataTestPrefix="account-settings-base-charts-delete"
        disabled={disabled}
      >
        <Text>{appstr("Confirm delete base chart")}</Text>
      </ConfirmationPopover>
    </Tooltip>
  );
};
